import axios from "axios";
import { REACT_APP_VMS_BASE_URL } from "../utils/urls";

const APIClient = axios.create({
  baseURL: REACT_APP_VMS_BASE_URL,
  headers: {},
});

export default APIClient;
